/**
 * Drop keys whose value is `undefined`, in the type as well as at runtime.
 *
 * Zod's `.optional()` infers `key?: T | undefined`, while Prisma's inputs and the
 * generated SDK's DTOs are `key?: T` — under `exactOptionalPropertyTypes` those are
 * different types, so a parsed body reaches neither without this. It lives here rather
 * than beside one of them because both ends of that mismatch are Zod's side of it.
 *
 * It is also the correct PATCH semantics rather than a type workaround: an absent key
 * means "leave it alone", and passing `undefined` through to Prisma would be indefensibly
 * close to passing `null`, which means "clear it".
 */
export function defined(value) {
    return Object.fromEntries(Object.entries(value).filter(([, field]) => field !== undefined));
}
//# sourceMappingURL=defined.js.map